export const styles = {
  chatWrapper: {
    width: '100%',
    maxHeight: '450px',
    overflowX: 'auto',
  },
}



// WEBPACK FOOTER //
// ./src/Containers/Mission/Details/Chat/style.js